import React, { useState } from 'react';
import { Button, Card, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { JobPositionSearch } from '../../components/JobPosition/JobPositionSearch';
import { JobPositionEditor } from '../../components/JobPosition/JobPositionEditor';
import { GetJobPositionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { JobPositionData } from '../../../common/spdCore/contexts/JobPositionContext';
import { CreateUpdateJobPositionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const JobPositionsView: React.FC = () => {
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [jobPosition, setJobPosition] = useState<GetJobPositionDto>();

  const handleAdd = () => {
    setShow(true);
    setJobPosition(undefined);
  };

  const handleClose = () => {
    setShow(false);
    setRefresh(!refresh);
  };

  const addEditJobPosition = async (
    jobPositionCu: CreateUpdateJobPositionDto,
    id?: string,
  ) => {
    try {
      if (id) {
        await spd.jobPositions.update(id, jobPositionCu);
      } else {
        await spd.jobPositions.create(jobPositionCu);
      }
      setShow(false);
      setRefresh(!refresh);
      return {
        saved: true,
        errors: [],
      };
    } catch (response) {
      return {
        saved: false,
        errors: await responseErrors(response as ResponseError),
      };
    }
  };

  const onRowClick = async (id: string) => {
    const jp = await spd.jobPositions.get(id);
    setJobPosition(jp);
    setShow(true);
  };

  return (
    <Card>
      <Tabs defaultActiveKey="search" id="jobPositions" className="mb-3">
        <Tab
          eventKey="search"
          title="Stanowiska predefiniowane"
          className="m-3"
        >
          <JobPositionSearch
            getData={spd.jobPositions.getAllByPortion}
            getCount={spd.jobPositions.getAllCount}
            refresh={refresh}
            onRowClick={onRowClick}
          />
          <Button variant="outline-primary" onClick={handleAdd}>
            Nowe stanowisko
          </Button>
          <JobPositionEditor
            id={jobPosition?.id}
            jobPosition={JobPositionData(jobPosition)}
            onCompleted={addEditJobPosition}
            show={show}
            handleClose={handleClose}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
